import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getAllCurrenciesService,
  getAllTransactionsService,
  getTransactionReportService
} from 'network/services/transaction.service'

export const fetchAllTransactions = createAsyncThunk(
  'fetch/allTransactions',
  async (data, thunkApi) => {
    try {
      const res = await getAllTransactionsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchAllCurrencies = createAsyncThunk(
  'fetch/allCurrencies',
  async (data, thunkApi) => {
    try {
      const res = await getAllCurrenciesService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchTransactionReport = createAsyncThunk(
  'fetch/transactionReport',
  async (data, thunkApi) => {
    try {
      const res = await getTransactionReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
